<template>
  <div class="school-student-rank">
    <div class="school-student-rank-header">
      <i></i>
      <span>Top 学校学生数量</span>
    </div>
    <div class="school-student-rank-main">
      <template v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="school-student-rank-main-item"
        >
          <div
            class="school-name"
            :title="`${item.schoolName}详情`"
            @click="goSchoolDetail(item)"
          >
            {{ item.schoolName }}
          </div>
          <div class="school-total">{{ item.activeStudentTotal }}</div>
        </div>
      </template>
      <div v-else style="margin-top: 20px; text-align: center">
        该区域下暂时没有学校
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SchoolStudentRank',
  props: {
    areaId: [Number, String],
    regionId: [Number, String],
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
    if (this.areaId) {
      this.onGetSchoolList()
    }
  },
  methods: {
    ...mapActions({
      getSchoolList: 'newStat/getSchoolList',
    }),
    async onGetSchoolList() {
      const data = {
        areaId: this.areaId,
        regionId: this.regionId,
        'x-page': 1,
        'x-per-page': 8,
        sortDirect: 'desc',
        sortField: 'activeStudentTotal',
        isActive: false,
      }
      const { rows } = await this.getSchoolList(data)
      this.list = rows
    },
    goSchoolDetail(row) {
      this.$router.push({
        name: 'SchoolDetail',
        query: {
          areaId: this.areaId,
          orgId: row.orgId,
          name: row.schoolName,
          schoolId: row.schoolId,
        },
      })
    },
  },
}
</script>

<style lang='scss'>
.school-student-rank {
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
  border-radius: 4px;
  .school-student-rank-header {
    height: 50px;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: #333;
    i {
      background-color: #2397f3;
      border-radius: 2px;
      width: 4px;
      height: 15px;
      margin-right: 10px;
    }
  }
  .school-student-rank-main {
    border-top: 1px solid #e8e8e8;
    padding: 8px 22px 0px;
    box-sizing: border-box;
    .school-student-rank-main-item {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #303133;
      font-size: 14px;
      &:not(:last-child) {
        border-bottom: 1px solid #e8e8e8;
      }
      .school-name {
        cursor: pointer;
        &:hover {
          color: #2397f3;
        }
      }
    }
  }
}
</style>